module.exports = __webpack_public_path__ + "img/dun.7de15a6b.png";